import * as React from 'react'

const SvgBus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={274}
    height={90}
    viewBox="0 0 274 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Bus_svg__a)">
      <path
        d="M111.068 90c6.702 0 12.136-5.431 12.136-12.13 0-6.7-5.434-12.132-12.136-12.132-6.703 0-12.136 5.431-12.136 12.131S104.365 90 111.068 90ZM251.564 90c6.703 0 12.136-5.431 12.136-12.13 0-6.7-5.433-12.132-12.136-12.132-6.702 0-12.136 5.431-12.136 12.131S244.862 90 251.564 90Z"
        fill="#440A78"
      />
      <path
        d="M9.345 71.876v-6.75a3.214 3.214 0 0 0-3.215-3.213H3.215A3.214 3.214 0 0 0 0 65.126v6.75a3.214 3.214 0 0 0 3.215 3.213H6.13a3.214 3.214 0 0 0 3.215-3.213Z"
        fill="#E1CEFF"
      />
      <path
        d="M22.508 0h198.274v77.869H4.675V17.826C4.675 7.988 12.666 0 22.508 0Z"
        fill="#7130C9"
      />
      <path
        d="M20.816 4.24h31.843c6.386 0 11.567 5.179 11.567 11.562v17.127H9.249V15.802c0-6.383 5.18-11.563 11.567-11.563ZM78.068 4.24h31.843c6.386 0 11.567 5.179 11.567 11.562v17.127H66.501V15.802c0-6.383 5.18-11.563 11.567-11.563ZM135.325 4.24h31.843c6.386 0 11.567 5.179 11.567 11.562v17.127h-54.977V15.802c0-6.383 5.181-11.563 11.567-11.563ZM192.582 4.24h1.032c6.386 0 11.567 5.179 11.567 11.562v17.127h-24.166V15.802c0-6.383 5.181-11.563 11.567-11.563Z"
        fill="#440A78"
      />
      <path
        d="M227.279 0h28.888C266.009 0 274 7.988 274 17.826v60.043h-64.554V17.826C209.446 7.988 217.437 0 227.279 0Z"
        fill="#E1CEFF"
      />
      <path
        d="M225.008 4.24h33.434c6.386 0 11.567 5.179 11.567 11.562v34.485h-56.568V15.802c0-6.383 5.181-11.563 11.567-11.563ZM65.653 38.932l-1.687 35.396-1.687-35.396c-.024-2.332 3.398-2.341 3.374 0ZM182.702 38.932l-1.687 35.396-1.687-35.396c-.024-2.332 3.398-2.341 3.374 0ZM11.389 38.48 9.702 73.874 8.015 38.48c-.024-2.331 3.398-2.341 3.374 0ZM125.445 38.932l-1.687 35.396-1.687-35.396c-.024-2.332 3.398-2.341 3.374 0ZM206.867 38.932l-1.686 35.396-1.687-35.396c-.024-2.332 3.398-2.341 3.373 0ZM40.822 90c6.703 0 12.136-5.431 12.136-12.13 0-6.7-5.433-12.132-12.136-12.132-6.702 0-12.136 5.431-12.136 12.131S34.12 90 40.822 90Z"
        fill="#440A78"
      />
      <path
        d="M181.319 90c6.702 0 12.135-5.431 12.135-12.13 0-6.7-5.433-12.132-12.135-12.132-6.703 0-12.136 5.431-12.136 12.131S174.616 90 181.319 90Z"
        fill="#440A78"
      />
      <path
        d="M40.822 83.81a5.941 5.941 0 1 0 0-11.881 5.941 5.941 0 1 0 0 11.88ZM181.319 83.81a5.94 5.94 0 1 0 0-11.881 5.942 5.942 0 0 0-5.943 5.94c0 3.28 2.661 5.94 5.943 5.94Z"
        fill="#E1CEFF"
      />
      <path
        d="M217.837 69.746a4.675 4.675 0 0 0 4.675-4.673 4.675 4.675 0 0 0-4.675-4.673 4.675 4.675 0 0 0-4.676 4.673 4.675 4.675 0 0 0 4.676 4.673ZM265.609 69.746a4.674 4.674 0 1 0-4.675-4.673 4.674 4.674 0 0 0 4.675 4.673Z"
        fill="#FFC103"
      />
      <path
        d="M252.971 60.4h-22.498a3.214 3.214 0 0 0-3.214 3.213v2.915a3.214 3.214 0 0 0 3.214 3.213h22.498a3.214 3.214 0 0 0 3.215-3.213v-2.915a3.214 3.214 0 0 0-3.215-3.213Z"
        fill="#7130C9"
      />
    </g>
    <defs>
      <clipPath id="Bus_svg__a">
        <path fill="#fff" d="M0 0h274v90H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBus
